import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: 16,
      paddingBottom: 24,
    },
    form: {
      paddingTop: 8,
    },
    submitGroup: {
      marginTop: 24,
    },
    error: {
      fontSize: 14,
      color: "#e02020",
      textAlign: "center",
      paddingTop: 80,
    },
  })
);

export default useStyles;
